import { createAction } from "@reduxjs/toolkit";
import type { FundingRequestVM } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveFundingRequest = createApiThunk<FundingRequestVM, string>(
  "fundingRequests/retrieveFundingRequest",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.get(id);
  },
);

export const resetRetrieveFundingRequest = createAction("fundingRequests/resetRetrieveFundingRequest");
